import React, { useState } from "react";
import {
  Box,
  Typography,
  IconButton,
  Drawer,
  List,
  ListItem,
  ListItemText,
  Grid,
} from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import logo from "../assets/logo2.png";
import { useNavigate, useLocation } from "react-router-dom";

const Header = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [open, setOpen] = useState(false);

  const menuItems = [
    { label: "Home", path: "/" },
    { label: "AboutUs", path: "/about-us" },
    { label: "Categories", path: "/categories" },
    { label: "Internship", path: "/internship" },
    { label: "News", path: "/news" },
  ];

  const isActive = (path) => location.pathname === path;

  return (
    <>
      <Grid
        sx={{
          width: "100%",
          position: "sticky",
          top: 0,
          px: { xs: 1, md: 3 },
          py: 2,
          background: "linear-gradient(60deg, #0D2A54, #1A4B83, #2B6BA5)",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          zIndex: 1000,
          // boxShadow: "0 4px 20px rgba(0,0,0,0.2)",
        }}
      >
        <Box
          component="img"

          src={logo}
          alt="logo"
          onClick={() => navigate("/")}
          sx={{
            width: {
              xs: 120,
              sm: 150,
              md: 200,
            },
            height: 200,
            maxHeight: 60,
            objectFit: "contain",
            cursor: "pointer",
            transition: "all 0.3s ease",
            "&:hover": {
              transform: "scale(1.3)",
            },
          }}
        />

        {/* DESKTOP MENU - WITH ACTIVE COLORS */}
        <Box
          sx={{
            display: { xs: "none", md: "flex" },
            alignItems: "center",
            gap: { md: 2, lg: 4 },
            flexShrink: 0,
            whiteSpace: "nowrap",
          }}
        >
          {menuItems.map((item) => (
            <Typography
              key={item.label}
              onClick={() => navigate(item.path)}
              sx={{
                fontSize: { md: 16, lg: 18 },
                fontWeight: 600,
                cursor: "pointer",
                color: isActive(item.path) ? "#FFD700" : "#fff",
                position: "relative",
                transition: "all 0.3s ease",
                "&:hover": {
                  color: "#FFD700",
                  transform: "translateY(-2px)",
                },
                "&::after": {
                  content: "''",
                  position: "absolute",
                  bottom: -8,
                  left: 0,
                  width: isActive(item.path) ? "100%" : "0%",
                  height: "2px",
                  background: "linear-gradient(90deg, #FFD700, #FFA500)",
                  transition: "width 0.3s ease",
                },
              }}
            >
              {item.label}
            </Typography>
          ))}
        </Box>

        {/* MOBILE MENU BUTTON */}
        <IconButton
          sx={{
            display: { xs: "block", md: "none" },
            color: "#fff",
            fontSize: 28,
          }}
          onClick={() => setOpen(true)}
        >
          <MenuIcon />
        </IconButton>
      </Grid>

      {/* MOBILE DRAWER */}
      <Drawer anchor="left" open={open} onClose={() => setOpen(false)}>
        <Box sx={{ width: 280, p: 3, bgcolor: "#0D2A54", flex: 1 }}>
          <Typography
            variant="h6"
            sx={{
              color: "#FFD700",
              fontWeight: "bold",
              mb: 4,
              textAlign: "center",
              fontSize: 20,
            }}
          >
            Menu
          </Typography>
          <List>
            {menuItems.map((item) => (
              <ListItem
                button
                key={item.label}
                onClick={() => {
                  navigate(item.path);
                  setOpen(false);
                }}
                sx={{
                  mb: 1,
                  borderRadius: 2,
                  transition: "all 0.3s ease",
                  bgcolor: isActive(item.path)
                    ? "rgba(255,215,0,0.2)"
                    : "transparent",
                  "&:hover": {
                    bgcolor: "rgba(255,215,0,0.1)",
                    transform: "translateX(8px)",
                  },
                }}
              >
                <ListItemText
                  primary={item.label}
                  primaryTypographyProps={{
                    fontWeight: 600,
                    color: isActive(item.path) ? "#FFD700" : "#fff",
                    fontSize: 16,
                  }}
                />
              </ListItem>
            ))}
          </List>
        </Box>
      </Drawer>
    </>
  );
};

export default Header;

